// Module
var code = "<div ui-view class=\"flex layout-column\"></div>\r\n";
// Exports
module.exports = code;